import { Component } from '@angular/core';


export class SkyTileContentComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tile-content',
  styles: [`:host /deep/ sky-tile-content-section:not(:last-child) .sky-tile-content-section {
  border-bottom: 1px solid #e2e3e4;
}
`],
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
